'use client';

import * as React from 'react';

import { useRouter } from 'next/navigation';

import { DiagnosticErrorFallback } from '@cntxt/shared/ui/feedback';

export type ErrorPageProps = {
  error: Error;
  reset?: () => void;
};

export function ErrorPage({
  error,
  reset,
}: Readonly<ErrorPageProps>): React.ReactElement {
  const router = useRouter();

  return (
    <DiagnosticErrorFallback
      error={error}
      reset={reset}
      onGoHome={() => router.push('/')}
      source="ErrorPage"
      layout="page"
      handleSessionExpiry
    />
  );
}
